import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { RootState } from "../../configureStore";

const selectState = (state: RootState) => state.dealNotificationModal;
export const selectQuestionContext = createDraftSafeSelector(selectState, (state) => state.context);
export const selectQuestionContextLoading = createDraftSafeSelector(selectState, (state) => state.contextLoading);
export const selectQuestionContextError = createDraftSafeSelector(selectState, (state) => state.contextError);
export const selectCreatedQuestionRequestId = createDraftSafeSelector(selectState, (state) => state.createdRequestId);

const makeSelectOpen = createDraftSafeSelector(selectState, (state) => state.open);
const makeSelectLoading = createDraftSafeSelector(selectState, (state) => state.loading);

const makeSelectDealNotifications = createDraftSafeSelector(selectState, (state) => state.dealNotifications);
const makeSelectDealId = createDraftSafeSelector(selectState, (state) => state.dealId);
const makeSelectManagerId = createDraftSafeSelector(selectState, (state) => state.managerId);
const makeSelectAdminOfficeType = createDraftSafeSelector(selectState, (state) => state.adminOfficeType);

export {
  selectState,
  makeSelectOpen,
  makeSelectLoading,
  makeSelectDealNotifications,
  makeSelectDealId,
  makeSelectManagerId,
  makeSelectAdminOfficeType,
};
